import { ILanguageInfo, ISearchlanguageInfo } from '../types';

export const getLanguageCodes = (languageInfo: ILanguageInfo[]) => {
  return languageInfo.map((countryInfo) => countryInfo.languageCode);
};

export const searchLanguageInfo = (props: ISearchlanguageInfo) => {
  const { languageInfo, locale, field } = props;
  const result = languageInfo.find(
    (countryInfo) => countryInfo.languageCode === locale
  );
  return field === 'language' ? result?.language : result?.countryCode;
};

export const redirectLanguageUrl = (
  languageInfo: ILanguageInfo[],
  locale: string
) => {
  const response = languageInfo.find(
    (countryInfo) => countryInfo.languageCode === locale
  );
  return response?.url;
};
